exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-d1[data-v-2d22e418]{margin-bottom:15px}.detail-lbl[data-v-2d22e418]{color:#4579b2;border-bottom:1px solid #d3d3d3}.detail-lbl-gry[data-v-2d22e418]{background-color:#f8f8f8;padding:7px;border:1px solid #e8e8e8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/ReadOnlyField.vue?vue&type=style&index=0&id=2d22e418&prod&scoped=true&lang=css&
// module id = 1589
// module chunks = 0